<!--Floating Buttons oben rechts "bearbeiten", "löschen", etc.-->
<!-- D277-5334
<div class="buttons" *ngIf="!(breakpointService.MobileQuery | async) || ShowButtons">
    <ng-container [ngTemplateOutlet]="BeforeButtons">

    </ng-container>
    <app-burger-button-wrapper *ngIf="Buttons" InvertedBurgerButton>
        <ng-container [ngTemplateOutlet]="Buttons"></ng-container>
    </app-burger-button-wrapper>
</div>
-->
<!-- Header Buttons -->
<app-top-button-wrapper class="buttons" *ngIf="(!(breakpointService.MobileQuery | async) || ShowButtons) && Buttons">
    <ng-container [ngTemplateOutlet]="Buttons"></ng-container>
</app-top-button-wrapper>

<!--<div class="scrollbar full-height wrapper">-->
    <div class="placeholder" *ngIf="ShowPlaceholder"></div>
<!-- die klasse wird auch in anderen komponenten mit ng-deep genutzt um den style von diesem element an zu passen-->
    <div class="top">
        <ng-container [ngTemplateOutlet]="TopContent"></ng-container>
    </div>
<!--<div class="resizer" *ngIf="Resizable" #resizer2></div>-->

    <div class="bottom" *ngIf="LeftContent || RightContent" [class.resizable]="Resizable">
        <div class="left">
            <ng-container [ngTemplateOutlet]="LeftContent"></ng-container>
        </div>
        <div class="resizer" *ngIf="Resizable" #resizer></div>
        <div class="right" [class.resizable]="Resizable">
            <ng-container [ngTemplateOutlet]="RightContent"></ng-container>
        </div>
    </div>
<!--</div>-->
